export default class FullWidthFaq {
  static init() {
    const faqSections = document.querySelectorAll('.full-width-faq');

    faqSections.forEach((faqElement) => {
      const triggers = faqElement.querySelectorAll('.full-width-faq__accordion-trigger');

      if (!triggers.length) return;

      // 1. INITIALIZATION ON LOAD
      triggers.forEach((trigger) => {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          trigger.closest('.full-width-faq__accordion').classList.add('is-open');
        }
      });

      // 2. CLICK EVENTS
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const clickedTrigger = e.currentTarget;
          const isExpanded = clickedTrigger.getAttribute('aria-expanded') === 'true';
          const currentAccordion = clickedTrigger.closest('.full-width-faq__accordion');

          // Close all accordions inside this specific Full Width FAQ block
          triggers.forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
            t.closest('.full-width-faq__accordion').classList.remove('is-open');
          });

          // Open the clicked one if it was closed
          if (!isExpanded) {
            clickedTrigger.setAttribute('aria-expanded', 'true');
            currentAccordion.classList.add('is-open');
          }
        });
      });
    });
  }
}